import { t } from "i18next";

export const CleanAndLimitString = (string, limit = 50) => {
  string = string.replace(/(<([^>]+)>)/gi, "");
  if (string.length > limit) {
    return string.substring(0, limit) + "...";
  } else {
    return string;
  }
};

export const DurationFormatterOptions = {
  BOTH: "BOTH",
  TOTAL: "TOTAL",
  HOURS_ONLY: "HOURS_ONLY",
  ALL_UNITS: "ALL_UNITS",
  ALL_UNITS_BOLD: "ALL_UNITS_BOLD",
};

export const DurationFormatter = (duration, options = "BOTH") => {
  if (!Number.isInteger(duration)) {
    return "";
  }
  const minutes = duration % 60;
  const hours = (duration - minutes) / 60;
  let result = "";

  switch (options) {
  case DurationFormatterOptions.HOURS_ONLY:
    let durationValue = duration / 60;
    durationValue = Number.isInteger(durationValue)
      ? durationValue
      : Math.ceil(durationValue * 10) / 10;
    return durationValue;

  case DurationFormatterOptions.ALL_UNITS:
  case DurationFormatterOptions.ALL_UNITS_BOLD:
    if (hours > 0) {
      const translationKey =
          minutes > 0
            ? options === DurationFormatterOptions.ALL_UNITS_BOLD
              ? "duration.hoursAndMinutes_boldTotal"
              : "duration.hoursAndMinutesTotal"
            : options === DurationFormatterOptions.ALL_UNITS_BOLD
              ? "duration.hours_boldTotal"
              : "duration.hoursTotal";
      return t(translationKey, {
        count: hours,
        minutes: minutes,
      });
    }
    if (minutes > 0) {
      return t(
        options === DurationFormatterOptions.ALL_UNITS_BOLD
          ? "duration.minutes_boldTotal"
          : "duration.minutesTotal",
        {
          count: minutes,
        }
      );
    }
    break;

  case DurationFormatterOptions.BOTH:
    if (hours > 0) {
      return t("duration.hoursTotal", {
        count: minutes > 0 ? (duration / 60).toFixed(1) : hours,
      });
    }
    if (minutes > 0) {
      return t("duration.minutesTotal", {
        count: minutes,
      });
    }
    break;
  case DurationFormatterOptions.TOTAL:
    if (hours > 0) {
      return minutes > 0 ? (duration / 60).toFixed(1) : hours;
    } else return minutes;
  default:
    return result;
  }

  return result;
};

export const DoesUrlMatch = (url, match, exact = false) => {
  if (exact) return url === match;
  return url.startsWith(match);
};
